export const CHANGE_THEME = 'CHANGE_THEME';

export const changeTheme = theme => ({
    type: CHANGE_THEME,
    payload: theme,
});

export const CHANGE_MENU_LAYOUT = 'CHANGE_MENU_LAYOUT';

/** layout: 'side' | 'top' */
export const changeMenuLayout = layout => ({
    type: CHANGE_MENU_LAYOUT,
    payload: layout,
});
